import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import Cookies from "js-cookie";
import { FetchDataTypes } from "../../api/api";
import { Line } from "react-chartjs-2";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { SectorActivityColumnDefs } from "../../columns/PerformanceColumns";
import {
  Chart,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  Filler,
} from "chart.js";
import { Pagination } from "../../components";
import {
  formateDatabuyCurr,
  formateDataCurr,
  formateDataPrec,
} from "../../utils/types";
import clsx from "clsx";
import _ from "lodash";
import { Grid, GridReadyEvent } from "ag-grid-community";
import "ag-grid-enterprise";
import { CsvExportModule } from "@ag-grid-community/csv-export";
import { ModuleRegistry } from "@ag-grid-community/core";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ExcelExportModule } from "@ag-grid-enterprise/excel-export";
import { MenuModule } from "@ag-grid-enterprise/menu";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { MultiSelect } from "react-multi-select-component";
import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable, { UserOptions } from "jspdf-autotable";

Chart.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  Filler
);
export interface IOlympicData {
  symbol: string;
  date: any;
  status: string;
  order: string;
  qty: string;
  price: number;
}
interface jsPDFCustom extends jsPDF {
  autoTable: (options: UserOptions) => void;
}
// Register the required feature modules with the Grid
ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  CsvExportModule,
  ExcelExportModule,
  MenuModule,
]);

function SectorActivity({ chartTitle }: { chartTitle: string }) {
  const dataGridRef = useRef<AgGridReact<IOlympicData>>(null);
  const dataGridRefMain = useRef<AgGridReact<IOlympicData>>(null);
  const securityDataGridRef = useRef<AgGridReact<IOlympicData>>(null);
  const [sectorAllocation, setSectorAllocation] = useState<any>(null);
  const [sectorDetails, setSectorDetails] = useState<any>(null);
  const [sectorCount, setSectorCount] = useState<any>(null);
  const [SectorCurrentPage, setSectorCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState("hide");
  const [selectedData, setSelectedData] = useState<any>(null);
  const [securityActivity, setSecurityActivity] = useState<any>([]);
  const [filteredData, setFilteredData] = useState<any>([]);
  const [tabIndex, setTabIndex] = useState(0);
  const [selected, setSelected] = useState<any>([]);
  const [selectedSecurity, setSelectedSecurity] = useState<any>(null);

  // useEffect(() => {
  //   FetchDataTypes("SectorActivity", Cookies.get("newJwt"))
  //     .then((response) => response.json())
  //     .then((response) => {
  //       setSectorAllocation(response);
  //     });
  // }, []);
  const selectedClient:any = Cookies.get("client")
  const onGridReady = useCallback((params: GridReadyEvent) => {
    FetchDataTypes("SectorActivity", parseInt(selectedClient), Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setSectorDetails(response);
        setSectorCount(response);
      });
  }, []);

  const newOnGridReady = useCallback((params: GridReadyEvent) => {
    FetchDataTypes("SecurityActivity", parseInt(selectedClient), Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setSecurityActivity(response);
      });
  }, []);

  const SectorpageHandler = (pageNumbers: any, index: any) => {
    setSectorDetails(
      sectorCount.slice(pageNumbers * 20 - 20, pageNumbers * 20)
    );
    setSectorCurrentPage(pageNumbers);
  };

  function currencyFormat(num: any) {
    return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }
  function formateAsPercent(num: any) {
    return new Intl.NumberFormat("default", {
      style: "percent",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(num / 100);
  }

  let security = [];
  security.push(
    sectorDetails?.map((e: any) => {
      return { label: e.sectorName, value: e.sectorName };
    })
  );

  const autoGroupColumnDef = useMemo(() => {
    return {
      minWidth: 200,
    };
  }, []);
  const SectorActivityColumnDefs = [
    {
      field: "sectorName",
      headerName: "Sector Name",
      width: 250,
      resizable: true,
      cellClass: "cell-wrap-text",
      flex: 1,
    },
    {
      field: "marketValue",
      headerName: "Market Value",
      width: 140,
      cellClass: "cell-wrap-text textAlign",
      cellRenderer: formateDataCurr,
      headerClass: "headerTextAlign",
    },
    {
      field: "buy",
      headerName: "Buy",
      cellRenderer: formateDatabuyCurr,
      width: 150,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },
    {
      field: "sell",
      headerName: "Sell",
      cellRenderer: formateDataCurr,
      width: 150,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },
    {
      field: "sectorGainLoss",
      headerName: "Gain/Loss",
      cellRenderer: formateDataCurr,
      width: 150,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },
    {
      field: "sectorPerf",
      headerName: "Sector Perf",
      cellRenderer: formateDataPrec,
      width: 140,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },
    {
      field: "sectorBenchmark",
      headerName: "Benchmark",
      width: 140,
      cellRenderer: formateDataPrec,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },
  ];

  const SecurityActivityColumns = [
    {
      field: "sectorName",
      headerName: "Sector Name",
      width: 200,
      resizable: true,
      cellClass: "cell-wrap-text",
      flex: 1,
      rowGroup: true,
      hide: true,
    },
    {
      field: "symbol",
      headerName: "Symbol",
      width: 80,
      resizable: true,
      cellClass: "cell-wrap-text",
    },
    {
      field: "perfDate",
      headerName: "Date",
      width: 100,
      resizable: true,
      headerClass: "textAlignCenter",
      cellClass: "cell-wrap-text textAlign",
      cellRenderer: "group",
      cellRendererParams: {
        innerRendererFramework: (p: any) => {
          return new Date(p.value).toLocaleDateString();
        },
      },
    },
    {
      field: "marketValue",
      headerName: "Market Value",
      width: 110,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
      cellRenderer: "group",
      cellRendererParams: {
        innerRendererFramework: formateDataCurr,
      },
    },
    {
      field: "buy",
      headerName: "Buy",
      width: 110,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
      cellRenderer: "group",
      cellRendererParams: {
        innerRendererFramework: formateDatabuyCurr,
      },
    },
    {
      field: "sell",
      headerName: "Sell",
      width: 120,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
      cellRenderer: "group",
      cellRendererParams: {
        innerRendererFramework: formateDataCurr,
      },
    },
    {
      field: "securityGainLoss",
      headerName: "Gain/Loss",
      width: 120,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
      cellRenderer: "group",
      cellRendererParams: {
        innerRendererFramework: formateDataPrec,
      },
    },
    {
      field: "securityPerf",
      headerName: "Perf",
      width: 110,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
      cellRenderer: "group",
      cellRendererParams: {
        innerRendererFramework: formateDataPrec,
      },
    },
    {
      field: "securityBenchmark",
      headerName: "Benchmark",
      width: 110,

      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
      cellRenderer: "group",
      cellRendererParams: {
        innerRendererFramework: formateDataPrec,
      },
    },
  ];

  function getRowData(e: any) {
    setSelectedData(e.data);
    setTabIndex(1);
  }

  useEffect(() => {
    setFilteredData(
      selectedData?.sectorName
        ? _.filter(securityActivity, { sectorName: selectedData?.sectorName })
        : _.filter(securityActivity, (securityActivity) =>
            _.map(selected, "value").includes(securityActivity?.sectorName)
          )
    );
  }, [securityActivity, selected, selectedData?.sectorName]);

  const onBtExport = useCallback(() => {
    dataGridRef.current!.api.exportDataAsExcel();
  }, []);
  const onBtExportMain = useCallback(() => {
    dataGridRefMain.current!.api.exportDataAsExcel();
  }, []);

  const onSecurityDataExport = useCallback(() => {
    securityDataGridRef.current!.api.exportDataAsExcel();
  }, []);

  function handleBenchMark(e: any) {
    selectedData?.sectorName
      ? setSelected([
          ...e,
          { label: selectedData?.sectorName, value: selectedData?.sectorName },
        ])
      : setSelected(e);
    setSelectedData({});
  }

  const exportSectorData = () => {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "portrait"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size) as jsPDFCustom;

    doc.setFontSize(12);

    const title = "Sector Activity";
    const headers = [
      [
        "Sector Name",
        "Market Value",
        "Buy",
        "Sell",
        "Gain/Loss",
        "Sector Perf",
        "Bench Mark",
      ],
    ];

    const data = sectorDetails.map((e: any) => [
      e.sectorName,
      e.marketValue,
      e.buy,
      e.sell,
      e.sectorGainLoss,
      e.sectorPerf,
      e.sectorBenchmark,
    ]);

    let content = {
      startY: 50,
      head: headers,
      body: data,
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save("sectorReport.pdf");
  };

  const exportSecurityData = () => {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "portrait"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size) as jsPDFCustom;

    doc.setFontSize(12);

    const title = "Security Activity";
    const headers = [
      [
        "Sector Name",
        "Symbol",
        "Date",
        "Market Value",
        "Buy",
        "Sell",
        "Gain/Loss",
        "Perf",
        "Bench Mark",
      ],
    ];
    const newData = filteredData.length ? filteredData : securityActivity;

    const data = newData.map((e: any) => [
      e.sectorName,
      e.symbol,
      e.perfDate.toString(),
      e.marketValue,
      e.buy,
      e.sell,
      e.securityGainLoss,
      e.securityPerf,
      e.securityBenchmark,
    ]);

    let content = {
      startY: 50,
      head: headers,
      body: data,
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save("securityReport.pdf");
  };

  return (
    <div className="card w-100">
      <div className="col-sm-3 w-100 d-flex py-3 justify-content-between tableFilters px-4">
        <h5 className="card-title float-start">Sector Activity</h5>
      </div>
      <div className="card-body">
        <div className="chart chart-xs">
          <div className="chartjs-size-monitor">
            <div className="chartjs-size-monitor-shrink">
              <div className="row">
                <Tabs
                  selectedIndex={tabIndex}
                  onSelect={(index) => setTabIndex(index)}
                >
                  <TabList>
                    <Tab>Sector</Tab>
                    <Tab>Security Activity</Tab>
                  </TabList>

                  <TabPanel>
                    <>
                      <div className="col-sm-12 my-3 text-end">
                        <i
                          className="align-middle me-2 far fa-fw fa-file-excel cursor-pointer"
                          style={{ fontSize: "16px" }}
                          onClick={onBtExportMain}
                        ></i>
                        <i
                          className="align-middle me-2 far fa-fw fa-file-pdf cursor-pointer"
                          onClick={() => exportSectorData()}
                          style={{ fontSize: "16px" }}
                        ></i>
                      </div>

                      <div
                        className="ag-theme-alpine"
                        style={{
                          height: "560px",
                          width: "100%",
                        }}
                      >
                        <AgGridReact
                          ref={dataGridRefMain}
                          rowData={sectorDetails}
                          columnDefs={SectorActivityColumnDefs}
                          onRowClicked={getRowData}
                          onGridReady={onGridReady}
                          pagination={true}
                          paginationPageSize= {20}
                        />

                        {/* <div className="row mt-4">
                <Pagination
                  data={sectorCount}
                  pageHandler={SectorpageHandler}
                  currentPage={SectorCurrentPage}
                  pageSize={50}
                  pageCount={true}
                />
              </div> */}
                      </div>
                    </>
                  </TabPanel>
                  <TabPanel>
                    <>
                      <div className="col-sm-12 my-3 d-flex justify-content-between">
                        <MultiSelect
                          options={security[0]}
                          value={selected}
                          onChange={handleBenchMark}
                          labelledBy="Select"
                          className="multiSelect"
                        />
                        <div className="float-end">
                          <i
                            className="align-middle me-2 far fa-fw fa-file-excel cursor-pointer"
                            style={{ fontSize: "16px" }}
                            onClick={onSecurityDataExport}
                          ></i>
                          <i
                            className="align-middle me-2 far fa-fw fa-file-pdf cursor-pointer"
                            onClick={() => exportSecurityData()}
                            style={{ fontSize: "16px" }}
                          ></i>
                        </div>
                      </div>
                      <div
                        className="ag-theme-alpine"
                        style={{
                          height: "500px",
                          width: "100%",
                        }}
                      >
                        <AgGridReact
                          ref={securityDataGridRef}
                          rowData={
                            filteredData.length
                              ? filteredData
                              : securityActivity
                          }
                          columnDefs={SecurityActivityColumns}
                          onGridReady={newOnGridReady}
                          autoGroupColumnDef={autoGroupColumnDef}
                          animateRows={true}
                          //pagination={true}
                          //paginationPageSize= {20}
                        />
                      </div>
                    </>
                  </TabPanel>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { SectorActivity };
